export default function findMessageKey(fields) {
	// eslint-disable-next-line object-curly-newline
	return fields.reduce((accumulator, { type, admin_label, key }) => {
		// eslint-disable-next-line camelcase
		const found = (type === 'textarea') && (admin_label === 'formComment');
		if (found) {
			// eslint-disable-next-line camelcase
			return key;
		}
		return accumulator;
	}, false);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/source-form-locators/findMessageKey.js